<template>
  <div class="Repayment-title">
    {{textTitle}}
    <div class="icon-return" @click=" getWalletPage">
      <img src="../../public/icons8-return.png" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      textTitle: ""
    };
  },
  methods: {
    getWalletPage() {
      if (this.$route.path == "/repayment")
      this.$router.push("/wallet");
      else {
        this.$router.push("/account");
      }
    },
    upText() {
      if (this.$route.path == "/MyProfileviews") this.textTitle = "Informational Details";
      else if (this.$route.path == "/myloan") this.textTitle = "My Loan";
      else if (this.$route.path == "/Myrepayment")
        this.textTitle = "Myrepayment";
      else if (this.$route.path == "/transaction")
        this.textTitle = "Transaction";
      else if (this.$route.path == "/setUp") this.textTitle = "Set Up";
      else if (this.$route.path == "/aboutUs") this.textTitle = "About Us";
          else if (this.$route.path == "/repayment") this.textTitle = "Repayment";
           else if (this.$route.path == "/success") this.textTitle = "Withdrawal Successful";

    }
  },
  mounted() {
    this.upText();
  }
};
</script>

<style>
img{
  cursor: pointer;
}
.Repayment-title {
  z-index: 99;
  position: fixed;
  left: 0;
  top: 0;
  color: #fff;
  height: 70px;
  line-height: 70px;
  text-align: center;
  font-size: 25px;
  background-color: #a95159;
  width: 100%;
}

.icon-return {
  position: absolute;
  top: 6px;
  left: 5%;
}

img {
  display: inline-block;
  color: #fff;
}
</style>
